import { AppProviders } from './providers'
import { AppRouter } from './router'
import { ApplicationErrorBoundary } from '../shared/errors/ApplicationErrorBoundary'

export function App() {
  return (
    <ApplicationErrorBoundary>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </ApplicationErrorBoundary>
  )
}
